import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "@/hooks/useSupabase";

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const { data: sessionData } = await supabase.auth.getSession();
        if (!sessionData.session) {
          setOk(false);
          setLoading(false);
          return;
        }
        const { data: profile } = await supabase
          .from("user_profiles")
          .select("role")
          .eq("id", sessionData.session.user.id)
          .maybeSingle();
        setOk(profile?.role === "admin");
      } catch {
        setOk(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-amber-500 rounded-full animate-spin" />
      </div>
    );
  }

  if (!ok) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}